import { Route, Routes } from "react-router-dom";
import SignInPage from "../pages/SignInPage";
import ProtectedRoute from "./ProtectedRoute";
import MasterLayout from "../masterLayout/MasterLayout";
import { renderRoutes } from "./routes-roles/RouteRenderer";
import { sharedRoutes } from "./routes-roles/shared.routes";
import { adminRoutes } from "./routes-roles/admin.routes";
import { mentorRoutes } from "./routes-roles/ mentor.routes";
import ErrorPage from "../pages/ErrorPage";
import { studentRoutes } from "./routes-roles/student.routes";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/sign-in" element={<SignInPage />} />

      <Route element={<ProtectedRoute />}>
        <Route element={<MasterLayout />}>
          {renderRoutes(sharedRoutes)}
          {renderRoutes(adminRoutes)}
          {renderRoutes(mentorRoutes)}
          {renderRoutes(studentRoutes)}
        </Route>
      </Route>

      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
};

export default AppRoutes;
